module.exports = __webpack_public_path__ + "static/media/presight-banner.058d77f1.jpg";